import React, {useState,useMemo,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';

import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';

import SubjectIcon from '@mui/icons-material/Subject';
import SpaceBarIcon from '@mui/icons-material/SpaceBar';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import DeleteIcon from '@mui/icons-material/Delete';
import FlagIcon from '@mui/icons-material/Flag';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoodIcon from '@mui/icons-material/Mood';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';

import Toast from './Toast';
import {Inc,Owner,Book,BookOption,BookOutline} from './Inc';
import {Tools} from './Tools';
import BookInputTabs from './BookInputTabs';
import BookInputName from './BookInputName';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    owner:Owner,
    book:Book,
    option:BookOption,
    cache_key:string,
    change(book:Book,option:BookOption):void,
    close():void,
}

let isEdit:boolean = false;
let targetIndex = 0;

const BookInputText = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const classes = useStyles();
    const defLines:BookOutline[] = [];
    const [states,setStates] = useState({
        book: Inc.defaultBook(),
        option: Inc.defaultBookOption(),
        outlines: defLines,
        toast:"",
        notFound: false,
        isLoading: true,
        isSerifu: false,
        isText: false,
    });
    const [commonEl, setCommonEl] = React.useState<null | HTMLElement>(null);

    const openCommonMenu = (e: React.MouseEvent<HTMLElement>) => {
        if( e.currentTarget.dataset.index ){
            //console.log( e.currentTarget.dataset.index );
            targetIndex = parseInt(e.currentTarget.dataset.index);
        }
        setCommonEl(e.currentTarget);
    };
  
    const closeCommonMenu = () => {
      setCommonEl(null);
    };

    const convOutlines = (option:BookOption)=>{
        //console.log("update_outlines",option);
        //console.log("cache_key",props.cache_key);
        setStates({...states,isLoading:true});
        Ajax.send("book/convoutlines",{book_id:props.book.book_id,cache_key:props.cache_key,option:option},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,outlines:res.outlines,option:option,isLoading:false,isText:res.is_text});
            } else {
                setStates({...states,toast:"エラー",isLoading:false});
            }
        },(err:any)=>{
            setStates({...states,toast:"エラー",isLoading:false});
        });
    }
    const saveOutlines = ()=>{
        setStates({...states,isLoading:true});
        //console.log(states.option);
        Ajax.send("book/updateb",{book_id:props.book.book_id,cache_key:props.cache_key,option:states.option,outlines:states.outlines},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,isLoading:false});
                props.change(props.book,states.option);
            } else {
                setStates({...states,toast:"エラー",isLoading:false});
            }
        },(err:any)=>{
            setStates({...states,toast:"エラー",isLoading:false});
        });
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
    }
    const closeName = ()=>{
        setStates({...states,isSerifu:false});
    }
    const edit = (flag:boolean)=>{
        isEdit = flag;
    }
    const clickLine = (e: React.MouseEvent<HTMLElement>)=>{
        if( !isEdit ){
            setStates({...states,toast:"各行の編集は微調整モードで行って下さい"});
            return;
        }
        //微調整のメニューを表示
        openCommonMenu(e);
    }
    const doMenu = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.id ){
            return;
        }
        if( e.currentTarget.dataset.id==="S1" ){
            //名前の指定
            setStates({...states,isSerifu:true});
        } else if( e.currentTarget.dataset.id==="T1" || e.currentTarget.dataset.id==="S2" || e.currentTarget.dataset.id==="H1" || e.currentTarget.dataset.id==="H2" ){
            let line = states.outlines[ targetIndex ];
            line.type = e.currentTarget.dataset.id;
            line.text = line.name + line.text;
            line.name = "";
            setStates({...states,outlines:states.outlines.slice(0,targetIndex).concat(line).concat( states.outlines.slice(targetIndex+1))});
        }　else if( e.currentTarget.dataset.id==="K1" ){
            const line:BookOutline = {
                type: "K1",
                name: "",
                text: "",
                yoko: "0",
            }
            setStates({...states,outlines:states.outlines.slice(0,targetIndex+1).concat(line).concat( states.outlines.slice(targetIndex+1))});
        }　else if( e.currentTarget.dataset.id==="EM" ){
            const line:BookOutline = {
                type: "T1",
                name: "",
                text: "",
                yoko: "0",
            }
            setStates({...states,outlines:states.outlines.slice(0,targetIndex+1).concat(line).concat( states.outlines.slice(targetIndex+1))});
        }　else if( e.currentTarget.dataset.id==="DL" ){
            setStates({...states,outlines:states.outlines.slice(0,targetIndex).concat( states.outlines.slice(targetIndex+1))});
        }　else if( e.currentTarget.dataset.id==="UN" || e.currentTarget.dataset.id==="IT" ){
            let line = states.outlines[ targetIndex ];
            if( e.currentTarget.dataset.id==="IT" ){
                line.yoko = "1";
            } else {
                line.yoko = "0";
            }
            setStates({...states,outlines:states.outlines.slice(0,targetIndex).concat(line).concat( states.outlines.slice(targetIndex+1))});
        }



        closeCommonMenu();
    }
    const updateName = (name:string)=>{
        let line = states.outlines[ targetIndex ];
        let text = line.name + line.text;
        
        line.type = "S1";
        line.text = text.substr(name.length);
        line.name = name;

        setStates({...states,outlines:states.outlines.slice(0,targetIndex).concat(line).concat( states.outlines.slice(targetIndex+1)),isSerifu:false});
    }
    const outlines = useMemo( ()=>{
        //console.log("generate_outlines");
		//console.log(states.outlines);
        return states.outlines.map( (line:any,index:number)=>{
            const key = "line" + index;
            let cl = "edit "+line.type;
            if( line.yoko==="1" ){
                cl = cl + " yoko";
            }
            let text = line.text;
            if( line.type==="K1" ){
                text = "（改ページ）";
            } else if( text==="" ){
                text = "　";
            }
            return (
                <div key={key} className={cl} onClick={clickLine} data-index={index}>
                    {line.type==="S1" &&
                    <span>{line.name}</span>
                    }
                    {text}
                </div>
            )
        })
    },[states.outlines]);
    
    useEffect( ()=>{
        window.scrollTo(0,0);
        isEdit = false;
        Ajax.send("book/outlines",{book_id:props.book.book_id,cache_key:props.cache_key},(res:any)=>{
            //console.log("outlines",res);
            if( res.ok ){
                setStates({...states,book:props.book,outlines:res.outlines,option:Inc.convBookOption(res.option),isText:res.is_text,isLoading:false});
            } else {
                setStates({...states,notFound:true});
            }
        },(err:any)=>{
            setStates({...states,notFound:true});
        });
    },[]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    if(states.isLoading){
        return (
            <Loading isLoading={true}/>
        )
    }

    const size = Tools.getModalSize();
    const style = {
        height: `${size.height-180}px`,
    }

    //console.log("book_input_text::render");

    let tabId = 1;
    if( !states.isText ){
        tabId = 3;
    }
    //console.log(tabId,states.outlines.length);

    return (
        <div id="book_input_text" className={classes.modalConfirm}>
			<div style={{position:'relative'}}>
				<h3 className="bookEditor"><span>B</span>原稿</h3>
				<div style={{position:'absolute',top:0,right:0,backgroundColor:'white'}}>
					<Button variant="outlined" color="primary" onClick={props.close}>閉じる</Button>
				</div>
			</div>
            <Grid container spacing={2} style={{marginTop:"1em"}}>
                <Grid item xs={12} sm={7}>
                    <div>
                        <div className="book_view">
                            <div className="book_outlines" style={style}>
                                <div className="book_outlines_inner">
                                    {outlines}
                                </div>
                            </div>
                        </div>
                        <div className="book_color_sample">
                            <div className="S1">セリフ</div>
                            <div className="H1">見出し 大</div>
                            <div className="H2">見出し 小</div>
                            <div className="K1">改ページ</div>
                            <div className="T1">ト書き</div>
                            <div className="han">※斜体の行は横書き</div>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <BookInputTabs owner={props.owner} book={states.book} option={states.option} update={convOutlines} save={saveOutlines} cache_key={props.cache_key} edit={edit} tabId={tabId}/>
                </Grid>
            </Grid>
            <Menu
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id="book-edit-menu-common"
                anchorEl={commonEl}
                keepMounted
                open={Boolean(commonEl)}
                onClose={closeCommonMenu}
            >
                <MenuItem data-id="T1" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <SubjectIcon/>
                    </ListItemIcon>
                    <ListItemText primary="ト書き"/>
                </MenuItem>
                <MenuItem data-id="S1" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <MoodIcon/>
                    </ListItemIcon>
                    <ListItemText primary="セリフ"/>
                </MenuItem>
                <MenuItem data-id="S2" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <InsertCommentIcon/>
                    </ListItemIcon>
                    <ListItemText primary="セリフの続き"/>
                </MenuItem>
                <MenuItem data-id="H1" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <FlagIcon/>
                    </ListItemIcon>
                    <ListItemText primary="見出し（大）"/>
                </MenuItem>
                <MenuItem data-id="H2" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <OutlinedFlagIcon/>
                    </ListItemIcon>
                    <ListItemText primary="見出し（小）"/>
                </MenuItem>
                <Divider/>
                <MenuItem data-id="K1" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <ViewAgendaIcon/>
                    </ListItemIcon>
                    <ListItemText primary="この後に改ページ"/>
                </MenuItem>
                <MenuItem data-id="EM" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <SpaceBarIcon/>
                    </ListItemIcon>
                    <ListItemText primary="この後に空の行"/>
                </MenuItem>
                <Divider/>
                <MenuItem data-id="UN" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <MoreVertIcon/>
                    </ListItemIcon>
                    <ListItemText primary="縦書き"/>
                </MenuItem>
                <MenuItem data-id="IT" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <MoreHorizIcon/>
                    </ListItemIcon>
                    <ListItemText primary="横書き"/>
                </MenuItem>
                <Divider/>
                <MenuItem data-id="DL" onClick={doMenu} classes={{root:"bookEditMenu"}}>
                    <ListItemIcon>
                        <DeleteIcon/>
                    </ListItemIcon>
                    <ListItemText primary="削除"/>
                </MenuItem>
            </Menu>
            <Toast close={closeToast} mes={states.toast}/>
            <BookInputName isOpen={states.isSerifu} line={states.outlines[targetIndex]} update={updateName} close={closeName}/>
        </div>
	);
}

export default BookInputText;
